var AddEditCertificateModule = /** @class */ (function () {
    function AddEditCertificateModule() {
    }
    return AddEditCertificateModule;
}());
export { AddEditCertificateModule };
